import React from 'react'

const SiteTitle = ({ siteTitle }) => (
    <div className="site-title">
    <h1 className="title">
      Cindy Sherry
    </h1>
    <h2 className="subtitle">
      Artist based in Nelson, British Columbia
    </h2>
  </div>
)

export default SiteTitle


// WEBPACK FOOTER //
// ./src/components/SiteTitle.js